/* Europe Mark Black Friday: accessible promo-code copy, including Shopify theme-editor reloads. */
(function () {
  if (window.__emBlackFridayCopyReady) return;
  window.__emBlackFridayCopyReady = true;

  function fallbackCopy(value) {
    var field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.left = '-9999px';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.focus();
    field.select();
    var successful = false;
    try { successful = document.execCommand('copy'); } catch (err) { successful = false; }
    document.body.removeChild(field);
    return successful;
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-em-bf-copy-code]');
    if (!button) return;
    var code = button.getAttribute('data-em-bf-copy-code');
    if (!code || button.disabled) return;
    var status = button.parentElement.querySelector('[data-em-bf-copy-status]');
    var label = button.querySelector('[data-em-bf-copy-label]');
    button.disabled = true;
    var copied = false;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(code);
        copied = true;
      } else {
        copied = fallbackCopy(code);
      }
    } catch (err) {
      copied = fallbackCopy(code);
    }

    if (label) label.textContent = copied ? 'COPIED!' : 'RETRY';
    button.classList.toggle('is-copied', copied);
    if (status) status.textContent = copied ? 'Discount code copied to clipboard.' : 'Unable to copy automatically. Please select and copy BLACKFRIDAY5.';
    window.setTimeout(function () {
      if (label) label.textContent = 'COPY';
      button.classList.remove('is-copied');
      button.disabled = false;
      if (status) status.textContent = '';
    }, 2200);
  });
})();
